import { Trans, useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import CardContent from '@material-ui/core/CardContent';
import {
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    Title,
    Tooltip,
} from 'chart.js';
import BlueFullWidthButton from 'components/BlueFullWidthButton/BlueFullWidthButton';

import Company from '../../../../types/Company';
import { StyledCard, StyledTitle } from './styled';

ChartJS.register(
    BarElement,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

interface Props {
    company: Company;
    updateData: () => void;
}

const Card4 = (props: Props) => {
    const { company } = props;
    const { chartData } = company;

    const { t } = useTranslation();
    const history = useHistory();

    const count = chartData?.pa?.count ?? 0;
    const kgPlastic = chartData?.pa?.kgPlastic ?? 0;
    const kgCo2 = chartData?.pa?.kgCo2 ?? 0;

    return (
        <StyledCard variant='outlined'>
            <CardContent style={{ height: '100%', minHeight: '300px' }}>
                <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                    <div>
                        <StyledTitle style={{ fontSize: '1.65rem', fontWeight: 500, marginBottom: '4px' }}>
                            <span>{t('pages.dashboard.cards.situation.title')}</span>
                        </StyledTitle>

                        {chartData.currentAssessmentState === 'certified' ? (
                            <StyledTitle style={{ fontSize: '1rem', marginTop: '16px', marginBottom: '24px' }}>
                                <Trans i18nKey='pages.dashboard.duplicate_pa_hint' />
                            </StyledTitle>
                        ) : (
                            <>

                                <StyledTitle style={{ fontSize: '1rem', marginTop: '16px', marginBottom: '24px' }}>
                                    <span>
                                        <Trans i18nKey='pages.dashboard.cards.situation.message' count={count} >

                                            {/*
                                            _<span style={{display: 'block', fontWeight: 'bold', margin: '8px 0'}}>{{count}}</span>_
                                            */}
                                            _<strong>{{ count }}</strong>_
                                        </Trans>
                                    </span>
                                </StyledTitle>

                                <StyledTitle style={{ fontSize: '1rem', marginBottom: '16px' }}>
                                    <span>
                                        <Trans i18nKey='pages.dashboard.cards.situation.kg_plastic_used' tOptions={{ value: kgPlastic }}>
                                            _<strong>{kgPlastic}</strong>_
                                        </Trans>
                                    </span>
                                </StyledTitle>

                                <StyledTitle style={{ fontSize: '1rem' }}>
                                    <span>
                                        <Trans i18nKey='pages.dashboard.cards.situation.kg_co2' tOptions={{ value: kgCo2 }} >
                                            _<strong>{{ kgCo2 }}</strong>_
                                        </Trans>
                                    </span>
                                </StyledTitle>

                                <div style={{ position: 'relative' }}>
                                    <div style={{ position: 'absolute', display: 'flex', width: '100%' }}>
                                        <div style={{ flexGrow: 1, flexBasis: '50px' }} />

                                        <div style={{ flexGrow: 1 }} />

                                        {/*
                                        <div style={{flex: 1, flexBasis: '50px', textAlign: 'right', marginBottom: isMobile ? '-16px' : undefined}}>
                                            <Chip color='primary' label='PA' style={{borderRadius: '5px', fontSize: '1.7em', height: '48px', paddingRight: '8px', marginRight: '-28px', marginTop: isMobile ? '8px' : '-30px'}}  />
                                        </div>
                                        */}
                                    </div>
                                </div>
                            </>
                        )}

                    </div>

                    <div style={{ flexGrow: 1 }} />

                    <BlueFullWidthButton variant='contained' color='primary' style={{ width: 'calc(100% + 44px)', margin: '24px -22px -18px' }} onClick={() => {
                        history.push('/plastic-assessments/' + chartData.currentAssessmentId + '/pa');
                    }} disabled={!chartData.currentAssessmentId || chartData.currentAssessmentState === 'certified'}>
                        {t('pages.dashboard.cards.situation.button')}
                    </BlueFullWidthButton>

                </div>

                {/*
                {isMobile && (
                    <div style={{height: '40px'}} />
                )}
                */}



                {/*
                    <div style={{flex: 1, flexBasis: '50px', textAlign: 'right', marginBottom: isMobile ? '-16px' : undefined}}>
                        <Chip color='primary' label='PA' style={{borderRadius: '5px', fontSize: '1.7em', height: '48px', paddingRight: '8px', marginLeft: isMobile ? undefined : '18px', marginRight: isMobile ? '-28px' : undefined, marginTop: isMobile ? '8%' : '130%'}}  />
                    </div>
                */}
            </CardContent>
        </StyledCard>
    );
};

export default Card4;
